module.exports = __webpack_public_path__ + "static/media/28DGC5.3aebe53e.jpg";